import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabSelectionType } from 'src/app/models/enums/tab-selection-type';

@Injectable({
    providedIn: 'root',
})
export class TabSelectedStateService {
    private onTabSelectionChange = new BehaviorSubject<TabSelectionType>(null);

    /**
     * Emet un événement lorsqu'un onglet est sélectionnée.
     */
    public get onTabSelectionChange$() {
        return this.onTabSelectionChange.asObservable();
    }

    /**
     * Retourne le type d'onglet selectionné.
     * @returns Le type d'onglet selectionné.
     */
    public getSelectedTabType(): TabSelectionType {
        return this.onTabSelectionChange.value;
    }

    /**
     * Spécifie le type d'onglet selectionné.
     * @param value: Le type d'onglet selectionné.
     */
    public setSelectedTabType(value: TabSelectionType) {
        this.onTabSelectionChange.next(value);
    }
}
